import React from 'react';
import About from '../About';
import Navbar from '../Navbar';
import Contact from '../Contact';
import './index.css';

const Portfolio = () => {
    return (
        <>
        <Navbar/>
        <div className='container-color about-mob'>
            <About/>
            <Contact/>
        </div>
        </>
    );
}

export default Portfolio;
